import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth2";
import { canAccessRoute, FREE_ROUTES, planKind } from "../../utils/plan-access";
import { MessageLockedResourceDialog, MessagePayedResourceDialog } from "../message-dialog";

/** Navegação com o gating de plano da sidebar (admin bypass, free→pago, conta bloqueada) */
export default function useGatedNavigate(): { navigateGated: (path: string, state?: unknown) => void; gateDialogs: ReactNode } {
  const navigate = useNavigate();
  const { user, isAdm } = useAuth();
  const [payedOpen, setPayedOpen] = useState(false);
  const [lockedOpen, setLockedOpen] = useState(false);

  const navigateGated = (path: string, state?: unknown) => {
    const opts = state !== undefined ? { state } : undefined;
    if (isAdm()) {
      navigate(path, opts);
      return;
    }
    if (!canAccessRoute(planKind(user.plan), path)) {
      setPayedOpen(true);
      return;
    }
    if (!user.unlocked && !FREE_ROUTES.includes(path)) {
      setLockedOpen(true);
      return;
    }
    navigate(path, opts);
  };

  const gateDialogs = (
    <>
      <MessagePayedResourceDialog open={payedOpen} onClose={() => setPayedOpen(false)} />
      <MessageLockedResourceDialog open={lockedOpen} onClose={() => setLockedOpen(false)} />
    </>
  );

  return { navigateGated, gateDialogs };
}
